import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { AppState, StateKeys } from './app.states';
import { authReducer } from '../auth-state/auth.reducer';
import { providerReducer } from '../provider/provider.reducer';
import { policyHolderReducer } from '../policyholder/policyholder.reducer';
import { dropdownReducer } from '../dropdown/dropdown.reducer';
import { notificationReducer } from '../notification/notification.reducer';

import { localStorageSync } from 'ngrx-store-localstorage';
import { ResetAllStores } from './app.actions';
import { enrolleeFeature } from '../enrollee/enrollee.reducer';

/** Root reducer map */
export const reducers: ActionReducerMap<AppState> = {
  [StateKeys.AUTH]: authReducer,
  [StateKeys.PROVIDER]: providerReducer,
  [StateKeys.POLICYHOLDER]: policyHolderReducer,
  [StateKeys.DROPDOWN]: dropdownReducer,
  [StateKeys.NOTIFICATION]: notificationReducer,

  [StateKeys.ENROLLEE]: enrolleeFeature.reducer,
};

/** MetaReducer for persistence */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [
      StateKeys.AUTH,
      StateKeys.PROVIDER,
      StateKeys.POLICYHOLDER,
      StateKeys.DROPDOWN,
    ],
    rehydrate: true,
    storageKeySerializer: key => `tamiin_${key}`,
  })(reducer);
}

export function clearStateMetaReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return function (state, action) {
    if (action.type === ResetAllStores.type) {
      // Keep dropdown state intact, reset other slices to their initial state
      const initialState: AppState = reducer(undefined as any, { type: '@@INIT' } as any);
      return {
        ...initialState,
        dropdown: state ? state.dropdown : initialState.dropdown,
      };
    }
    return reducer(state, action);
  };
}


export const metaReducers: MetaReducer[] = [clearStateMetaReducer, localStorageSyncReducer];
